import { useRouter } from 'next/router';

import useMedia from '~hooks/useMedia';
import { setGtmDataLayer } from '~utils/common/thirdPartyEvent';

import { MENU_TYPE, MENU_TYPE_OBJ } from '../constants';
import { LNB_LIST } from './constants';
import { getSelectedkMenu } from './helper';
import Menu from './Menu';
import * as S from './style';
import Tabs from './Tabs';

interface Props {
  selectedMenu: MENU_TYPE;
  setSelectedMenu: (menu: MENU_TYPE) => void;
}

function LNB({ selectedMenu, setSelectedMenu }: Props) {
  const router = useRouter();
  const { isDesktop } = useMedia();

  const onClickMenu = (menuType: MENU_TYPE) => {
    const lnbMenu = getSelectedkMenu(menuType);

    setGtmDataLayer('theme__click', { theme: lnbMenu?.text || '' });

    setSelectedMenu(menuType || MENU_TYPE_OBJ.DALIY_VIEW_RANK);
    const params = new URLSearchParams({ selectedMenu: menuType });

    router.replace(
      {
        pathname: '/',
        search: params.toString(),
      },
      undefined,
      { scroll: false },
    );
  };

  return (
    <S.LNBWrapper>
      {isDesktop ? (
        <>
          {LNB_LIST.map((option) => (
            <Menu
              key={option.id}
              menuType={option.id}
              onClick={onClickMenu}
              selected={option.id === selectedMenu}>
              <span data-value={option.id}>{option.text}</span>
            </Menu>
          ))}
          <S.Divider />
        </>
      ) : (
        <Tabs selectedMenuId={selectedMenu} menuList={LNB_LIST} onClick={onClickMenu} />
      )}
    </S.LNBWrapper>
  );
}

export default LNB;
